'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function scrollLock() {
  var lock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var body = document.querySelector('body');
  body.style.overflow = lock ? 'hidden' : 'unset';
}

exports.default = scrollLock;
